import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/customization/appsetup/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

import { Offcanvas } from "react-bootstrap";

function Edit({ show, onHide, id, setShowError, setSuccess, setErr }) {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");
  const advertisementimageFile = watch("advertisement_image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("platform_percent", data?.platform_percent);
      sendData.append("transport_distance", data?.transport_distance);
      sendData.append("min_km_transport", data?.min_km_transport);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        setSuccess(true);
        setModalShow(true);
        setTimeout(() => {
          onHide();
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };
  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit App Set Up</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="forms_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
              

                <div className="form-group">
                  <Form.Label>Platform Percent </Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Platform Percent"
                    {...register("platform_percent", {
                      required: "Platform Percent  is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.platform_percent,
                    })}
                  />
                  {errors.platform_percent && (
                    <span className="text-danger">
                      {errors.platform_percent?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Transport Nearby Distance</Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Transport Nearby Distance"
                    {...register("transport_distance", {
                      required: "Transport Nearby Distance is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.transport_distance,
                    })}
                  />
                  {errors.transport_distance && (
                    <span className="text-danger">
                      {errors.transport_distance?.message}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <Form.Label>Minimum Km for Transport</Form.Label>
                  <Form.Control

                    type="text"
                    name=""
                    placeholder="Minimum Km for Transport"
                    {...register("min_km_transport", {
                      required: "Minimum Km for Transport is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.min_km_transport,
                    })}
                  />
                  {errors.min_km_transport && (
                    <span className="text-danger">
                      {errors.min_km_transport?.message}
                    </span>
                  )}
                </div>

              </div>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        onHide();
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <Successfull_Modal
          message={"Successful"}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Edit;
